import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ebde4e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "icon fas fa-caret-up" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_dropdown = _resolveComponent("o-dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString($setup.hhName), 1),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Loading..."))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", null, [
      _createVNode(_component_ag_grid_vue, {
        class: "ag-theme-alpine",
        rowData: $setup.hhData,
        domLayout: "autoHeight",
        defaultColDef: $setup.defaultColDef,
        columnDefs: $setup.summaryColumnDefs.value,
        onGridReady: $setup.onGridReady
      }, null, 8, ["rowData", "defaultColDef", "columnDefs", "onGridReady"])
    ]),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.singleAccountsData, (account, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: account.AccountID,
        class: "recent-sales-container my-5"
      }, [
        _createElementVNode("h2", null, _toDisplayString($setup.singleAccountsData[index].AccountName), 1),
        _createVNode(_component_o_dropdown, {
          class: "recent-sales-wrap",
          mobileModal: false
        }, {
          trigger: _withCtx(({ active }) => [
            _createVNode(_component_o_button, {
              variant: "primary",
              outlined: "",
              key: active,
              class: "toggle-button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(active ? "Hide recent sales" : "Show recent sales"), 1),
                _withDirectives(_createElementVNode("i", _hoisted_4, null, 512), [
                  [_vShow, active]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("i", {
                  class: "icon fas fa-caret-down",
                  key: active
                }, null, 512)), [
                  [_vShow, !active]
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ag_grid_vue, {
              class: "ag-theme-alpine recent-sales",
              rowData: $setup.singleAccountsData[index].RecentSales,
              domLayout: "autoHeight",
              defaultColDef: $setup.defaultColDef,
              columnDefs: $setup.recentSalesColumnDefs.value,
              suppressAggFuncInHeader: true,
              groupDefaultExpanded: 1
            }, null, 8, ["rowData", "defaultColDef", "columnDefs"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_ag_grid_vue, {
          class: "ag-theme-alpine",
          rowData: account.CashAndCashEquivalent,
          domLayout: "500",
          style: {"height":"50rem"},
          defaultColDef: $setup.defaultColDef,
          columnDefs: $setup.singleAccountColumnDefs.value,
          suppressAggFuncInHeader: true,
          groupDefaultExpanded: 1
        }, null, 8, ["rowData", "defaultColDef", "columnDefs"])
      ]))
    }), 128))
  ]))
}